export enum DeviceEqualizerContour {
	HighPass = 'HIGH_PASS',
	LowShelf = 'LOW_SHELF',
	MultiBand = 'MULTI_BAND',
	Off = 'OFF',
	Unknown = 'UNKNOWN'
}
